import { firebase_app } from "@/firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseAuth = getAuth(firebase_app);

export {
    firebaseAuth,
}

